import "../assets/mmenu/jquery.mmenu.js";
import "../assets/mmenu/addons/fixedelements/jquery.mmenu.fixedelements.js";
import {AuwMobileMenu} from "./AuwMobileMenu";

new AuwMobileMenu($('#mobileMenu__clicker'));

